<template>
  <div class="footer cl">
    <p class="logo"><img :src="flogo" alt="" /></p>
    <div class="content cl" v-html="data"></div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { getFoot } from "@/common/api.js";
export default {
  name: "Foot",
  components: {},
  props: {},
  data() {
    return {
      flogo: require("@/assets/images/flogo.png"),
      lang: this.$route.query.language || "zh",
      data: "",
    };
  },
  created() {
    this.getFootData(this.lang);
  },
  mounted() {},
  methods: {
    getFootData(lang) {
      let that = this;
      getFoot({ language: lang }).then((res) => {
        if (res.status == 200) {
          that.data = res.data.data.content;
        } else {
          console.log(res.statusText);
        }
      });
    },
    langSelect: function (param) {
      this.getFootData(param);
    },
  },
  computed: {
    // ...mapState({
    //   lang: (state) => state.lang,
    // }),
  },
};
</script>
<style scoped>
.footer ul li,
.footer ul {
  list-style: none;
}
.footer ul {
  display: inline-block;
}
.footer ul li {
  float: left;
  margin-right: 5px;
}
.link,
.copyRight {
  width: 100%;
  text-align: center;
}
.footer a {
  color: #a4a3a3;
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
}
.copyRights a {
  margin-right: 20px;
}
.copyRights a:last-child() {
  margin-right: 0;
}
</style>













// WEBPACK FOOTER //
// src/components/Foot.vue